import { render, staticRenderFns } from "./CustomGroupCheckboxesField.vue?vue&type=template&id=780c778a&scoped=true&"
import script from "./CustomGroupCheckboxesField.vue?vue&type=script&lang=js&"
export * from "./CustomGroupCheckboxesField.vue?vue&type=script&lang=js&"
import style0 from "./CustomGroupCheckboxesField.vue?vue&type=style&index=0&id=780c778a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780c778a",
  null
  
)

export default component.exports